const DEFAULT_BRAND_COLORS = {
  PRIMARY: '#263E53',
  SECONDARY: '#EEBC00',
} as const;

export default DEFAULT_BRAND_COLORS;
